import { render, staticRenderFns } from "./AddFreeSkillOthers.vue?vue&type=template&id=47e79b56&scoped=true&"
import script from "./AddFreeSkillOthers.vue?vue&type=script&lang=js&"
export * from "./AddFreeSkillOthers.vue?vue&type=script&lang=js&"
import style0 from "./AddFreeSkillOthers.vue?vue&type=style&index=0&id=47e79b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e79b56",
  null
  
)

export default component.exports